import React from 'react';
import LinkSelect, { type Props } from './view.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => <LinkSelect {...props} />;
